export const
    INITIALIZE_SECTION = "PROFILE.INITIALIZE_SECTION";

export const
    initializeSection = (clientId, isAdviserArea, page, pivotId, stepId) => ({
        type: INITIALIZE_SECTION,
        clientId,
        isAdviserArea,
        page,
        pivotId,
        stepId,
    });